import * as PROJECT_CODE from '../../constants/projectCode';
import firebase from '../../lib/firebase.prod';

const firebaseRef = firebase.database();

export async function assignLeadSalesAgent(leadsKey, value) {
	var leadsRef = firebaseRef.ref(
		'/kavtek_leads/' + PROJECT_CODE.projectCode + '/' + leadsKey
	);

	//update the database with the assigned salesagents
	leadsRef.update({
		leadToSalesAgent: value,
	});
}
